(function () {
  const deleteColorSchemes = (element) => {
    element.classList.forEach(className => {
      if (className.startsWith('color-background-') && className != 'color-background-overlay') {
        element.classList.remove(className);
      }
    });
  }

  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;
    const menu = document.querySelector(".list-menu--inline");
    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector("details-modal.header__search");
    const searchModal = document.querySelector("details-modal.header__search > details");
    const allSubmenu = document.querySelectorAll(".header__submenu");
    const isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";
    const main = document.getElementById('MainContent')
		const headerSimpleMegaMenus = header.querySelectorAll('[data-simple-mega-menu]');
    const sections = main.querySelectorAll('.shopify-section')
    const sectionFirstChildTransparent = sections[0]?.querySelector(
      '[data-header-transparent]'
    )
    const headerTransparent = header
    .querySelector('.header-wrapper')
    .classList.contains('header-wrapper--full-width')

    const closeDesktopMenus = () => {
      header.classList.add("header-menu-force-closed");
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu-item--inactive");
        link.classList.remove("list-menu-item--active");
        link.classList.remove("list-menu--megamenu-visible");
      });

      document.querySelector('.header__overlay')?.classList.remove('active');
      document.querySelectorAll(".header__submenu-item").forEach((link) => {
        link.classList.remove("header__submenu-item--inactive");
      });

      if (header.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    };

    const allowDesktopMenus = () => {
      header.classList.remove("header-menu-force-closed");
    };
    
    if (isLightLogo == 'true')
			header.classList.add('header--light-logo');
    else
      header.classList.remove('header--light-logo');

    if (!(sectionFirstChildTransparent && headerTransparent)) {
      deleteColorSchemes(header);
      header.classList.remove("color-background-overlay");
    }

    const isAustraliaStorefront = () =>
      (window.location.pathname === '/en-au' || window.location.pathname.startsWith('/en-au/')) ||
      window.location.hostname.includes('shopifypreview.com');

    const australiaAccessoriesMenuProducts = [
      {
        handle: 'deye-data-logger-series-wifi-4g-ethernet-monitoring-accessories',
        title: 'Deye Data Logger Series | WiFi / 4G / Ethernet Monitoring Accessories',
        image: 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/www.deyeinverter.com_deyeinverter_2025_08_12_stick-logger.png?v=1780299762',
        alt: 'Deye Data Logger Series WiFi and Ethernet monitoring accessories',
      },
      {
        handle: 'deye-single-phase-meter-ddsu666',
        title: 'CHINT Single-phase Meter DDSU666',
        image: 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/DDSU666.png?v=1778050108',
        alt: 'Deye DDSU666 - single-phase smart energy meter for solar PV monitoring',
      },
      
      
      {
        handle: 'deye-ai-w5-1-b-pdu1-base',
        title: 'Deye AI-W5.1-B-PDU1 + Base | Low-Voltage Stackable Battery Control & Mounting Set',
        image: 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/new1.jpg?v=1780024333',
        alt: 'Deye AI-W5.1-B-PDU1 + Base low-voltage stackable battery control and mounting set',
      },
      {
        handle: 'deye-dc-combiner-box-300',
        title: 'Deye DC Combiner Box 300 | High-Voltage Battery Combiner Box',
        image: 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/17984-Combiner_Box_1920x1920_c56b6c0e-29ff-4036-8636-abc8cccb3b5b.png?v=1776243412',
        alt: 'Deye DC Combiner Box 300 high-voltage battery combiner box',
      }
];
    const australiaWirelessMenuProducts = [
      {
        handle: 'deye-smart-wallbox-ac-charger-sun-evse11k01-eu-ac',
        title: 'Deye Smart Wallbox | AC-Charger | SUN-EVSE11K01-EU-AC',
        image: 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/E6_AD_A3_E8_A7_86_E5_9B_BE-2.png?v=1766800671',
        alt: 'Deye SUN-EVSE11K01-EU-AC 11 kW smart EV wallbox AC charger',
      },
    
		{
			handle: 'deye-smart-plug-sun-smart-plug01p1-f',
			title: 'Deye Smart Plug| SUN-SMART-PLUG01P1-F',
			image: 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/SUN-SMART-PLUG01P1-F-a.png?v=1773466473',
			alt: 'Deye SUN-SMART-PLUG01P1-F – Wi-Fi smart plug for home energy monitoring and control',
		},
	
		{
			handle: 'deye-smart-switch-sun-smart-switch01p3',
			title: 'Deye Smart Switch| SUN-SMART-SWITCH01P3',
			image: 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/SUN-SMART-SWITCH01P3-a.png?v=1773467024',
			alt: 'Deye SUN-SMART-SWITCH01P3 – Wi-Fi smart switch for home energy management',
		},
	];

    const getProductHandle = (path) => {
      const match = path.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    };

    const buildAustraliaMenuCard = (product, collectionHandle) => {
      const item = document.createElement('li');
      item.className = 'header__submenu-products-item';
      item.innerHTML = `
        <a href="/en-au/collections/${collectionHandle}/products/${product.handle}" class="header__submenu-products-link" aria-label="${product.title.replace(/"/g, '&quot;')}">
          <div class="header__submenu-products-media">
            <img src="${product.image}" width="240" height="240" loading="lazy" class="header__submenu-products-image" alt="${product.alt.replace(/"/g, '&quot;')}">
          </div>
          <div class="header__submenu-products-content">
            <span class="header__submenu-products-title">${product.title}</span>
          </div>
        </a>
      `;
      return item;
    };

    const hydrateAustraliaAccessoriesMenu = () => {
      if (!isAustraliaStorefront()) return;

      header.querySelectorAll('.header__submenu-products').forEach((productsBlock) => {
        const heading = productsBlock.querySelector('.header__submenu-products-heading')?.textContent?.trim();
        if (heading !== 'Accessories') return;

        const list = productsBlock.querySelector('.header__submenu-products-list');
        if (!list) return;

        const existingHandles = new Set(
          Array.from(list.querySelectorAll('a[href*="/products/"]'))
            .map((link) => getProductHandle(link.pathname))
            .filter(Boolean)
        );

        list.querySelectorAll('a[href*="/products/logger-dl1000b-wifi"]').forEach((link) => {
          link.closest('.header__submenu-products-item, li')?.remove();
          existingHandles.delete('logger-dl1000b-wifi');
        });
        list
          .querySelectorAll('a[href*="/products/deye-data-logger-series-wifi-4g-ethernet-monitoring-accessories"]')
          .forEach((link, index) => {
            const item = link.closest('.header__submenu-products-item, li');
            if (index > 0) {
              item?.remove();
            } else if (item && item !== list.firstElementChild) {
              list.insertBefore(item, list.firstElementChild);
            }
          });
        const hasDataLogger = Boolean(
          list.querySelector(
            'a[href*="/products/deye-data-logger-series-wifi-4g-ethernet-monitoring-accessories"]'
          )
        );
        australiaAccessoriesMenuProducts.forEach((product) => {
          if (
            product.handle === 'deye-data-logger-series-wifi-4g-ethernet-monitoring-accessories' &&
            hasDataLogger
          ) {
            return;
          }
          if (!existingHandles.has(product.handle)) {
            const card = buildAustraliaMenuCard(product, 'accessories');
            if (product.handle === 'deye-data-logger-series-wifi-4g-ethernet-monitoring-accessories') {
              list.insertBefore(card, list.firstElementChild);
            } else {
              list.appendChild(card);
            }
          }
        });

        list.classList.remove(
          'header__submenu-products-list--count-1',
          'header__submenu-products-list--count-2',
          'header__submenu-products-list--count-3'
        );
        list.classList.add('header__submenu-products-list--count-4');
      });
    };

    const hydrateAustraliaWirelessMenu = () => {
      if (!isAustraliaStorefront()) return;

      header.querySelectorAll('.header__submenu-products').forEach((productsBlock) => {
        const heading = productsBlock.querySelector('.header__submenu-products-heading')?.textContent?.trim();
        if (heading !== 'Deye Wireless Energy Management System') return;

        const list = productsBlock.querySelector('.header__submenu-products-list');
        if (!list) return;

        const existingHandles = new Set(
          Array.from(list.querySelectorAll('a[href*="/products/"]'))
            .map((link) => getProductHandle(link.pathname))
            .filter(Boolean)
        );

        australiaWirelessMenuProducts.forEach((product) => {
          if (!existingHandles.has(product.handle)) {
            list.appendChild(buildAustraliaMenuCard(product, 'deye-wireless-energy-management-system'));
          }
        });
      });
    };

    const removeAustraliaEmptyAccessoriesCards = () => {
      if (!isAustraliaStorefront()) return;
      header
        .querySelectorAll('.header__submenu-products a[href$="/collections/accessories/products/"], .header__submenu-products img[src^="&width="]')
        .forEach((node) => {
          const item = node.closest('.header__submenu-products-item, li');
          (item || node).remove();
        });
    };

    hydrateAustraliaAccessoriesMenu();
    hydrateAustraliaWirelessMenu();
    removeAustraliaEmptyAccessoriesCards();

    const activateSimpleMegaItem = (simpleMenu, activeKey) => {
      const items = simpleMenu.querySelectorAll('[data-simple-mega-trigger]');
      const panels = simpleMenu.querySelectorAll('[data-simple-mega-panel]');

      items.forEach((item) => {
        const isActive = item.dataset.simpleMegaTrigger === activeKey;
        const link = item.querySelector('.header__submenu-item');

        item.classList.toggle('is-open', isActive);

        if (link) {
          link.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-open', panel.dataset.simpleMegaPanel === activeKey);
      });
    };

		headerSimpleMegaMenus.forEach((simpleMenu) => {
      const openableItems = Array.from(simpleMenu.querySelectorAll('[data-simple-mega-trigger]'));

      if (!openableItems.length) {
        return;
      }

      const defaultKey =
        openableItems.find((item) => item.classList.contains('is-open'))?.dataset.simpleMegaTrigger
        || openableItems[0].dataset.simpleMegaTrigger;

      activateSimpleMegaItem(simpleMenu, defaultKey);

      openableItems.forEach((item) => {
        const showPanel = () => {
          activateSimpleMegaItem(simpleMenu, item.dataset.simpleMegaTrigger);
        };

        item.addEventListener('mouseenter', showPanel);
        item.addEventListener('focusin', showPanel);
      });

      simpleMenu.addEventListener('mouseleave', () => {
        activateSimpleMegaItem(simpleMenu, defaultKey);
      });
    });

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search.isOpen) {
        search.close();
      }
    });

    /*const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        document.documentElement.style.setProperty("--ann-height", `${entry.boundingClientRect.height}px`);
      } else {
        document.documentElement.style.setProperty("--ann-height", `0px`);
      }
    });

    if (annBar) {
      annBarObserver.observe(annBar);
    } else {
      document.documentElement.style.setProperty("--ann-height", `0px`);
    }*/

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        const hasDesktopMenu = link.classList.contains("list-menu--megamenu") || link.classList.contains("list-menu--submenu");

        if (!hasDesktopMenu) {
          closeDesktopMenus();
          return;
        }

        allowDesktopMenus();
        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");
          document.querySelector('.header__overlay').classList.add('active');

          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
              //document.querySelector('.header__overlay').classList.remove('active');
            }
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
        } else {
          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            el.classList.remove("list-menu--megamenu-visible");
            document.querySelector('.header__overlay').classList.remove('active');
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
        }
      });
    });

    document.body.addEventListener('mousedown', function() {
			document.body.classList.add('mouse-focus');
		});

		document.body.addEventListener('keydown', function(e) {
				if (e.key === 'Tab') {
					document.body.classList.remove('mouse-focus');
				}
		});

    allSubmenu.forEach((submenu) => {
      const links = submenu.querySelectorAll(".header__submenu-item:not(.header__submenu-item--grandchild)");

      links.forEach((link) => {
        const childLinks = link.parentElement.querySelectorAll(".header__submenu-item--grandchild");

        link.addEventListener("mouseenter", (e) => {
          links.forEach((el) => {
            el.classList.add("header__submenu-item--inactive");
          });
          link.classList.remove("header__submenu-item--inactive");
        });

        childLinks.forEach((childLink) => {
          childLink.addEventListener("mouseenter", (e) => {
            childLinks.forEach((el) => {
              el.classList.add("header__submenu-item--inactive");
            });
            childLink.classList.remove("header__submenu-item--inactive");
          });
        });

        link.addEventListener("mouseleave", (e) => {
          childLinks.forEach((el) => {
            el.classList.remove("header__submenu-item--inactive");
          });
        });
      });

      submenu.addEventListener("mouseleave", (e) => {
        links.forEach((el) => {
          el.classList.remove("header__submenu-item--inactive");
        });
      });
    });

    menu?.addEventListener("mouseleave", closeDesktopMenus);
    header.addEventListener("mouseleave", closeDesktopMenus);
    document.querySelector('.header__overlay')?.addEventListener("mouseenter", closeDesktopMenus);
    document.addEventListener("pointermove", (event) => {
      if (!header.contains(event.target)) {
        closeDesktopMenus();
      }
    });
    document.addEventListener("pointerdown", (event) => {
      if (!header.contains(event.target)) {
        closeDesktopMenus();
      }
    });

    if (header && header.classList.contains("color-background-overlay")) {
      const colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
      header.addEventListener("mouseenter", () => {
        header.classList.remove("color-background-overlay");
        /*if (colorScheme)
          header.classList.remove(colorScheme);*/
        deleteColorSchemes(header);
        header.classList.add("color-background-overlay-hidden");
      });

      header.addEventListener("mouseleave", () => { 
        if (!searchModal.hasAttribute("open")) {
          if (!header.classList.contains('shopify-section-header-sticky') 
            && !header.classList.contains('shopify-section-header-scroll')
            && !header.querySelector('.menu-drawer-container').classList.contains('menu-opening')
          ) {
            const main = document.getElementById('MainContent')
            const sections = main.querySelectorAll('.shopify-section')
            const sectionFirstChildTransparent = sections[0]?.querySelector(
              '[data-header-transparent]'
            )
            const headerTransparent = header
            .querySelector('.header-wrapper')
            .classList.contains('header-wrapper--full-width')
            
            if (sectionFirstChildTransparent && headerTransparent) {
              header.classList.add("color-background-overlay");
              if (colorScheme)
                header.classList.add(colorScheme);
            }
            header.classList.remove("color-background-overlay-hidden");
          }
        }
      });
    }

    const buttons = header.querySelectorAll('.js-open-list-menu-item')

		buttons.forEach((button) => {
			button.addEventListener('click', (event) => {
				const submenu = event.currentTarget.closest('.header__submenu')
				const items = submenu.querySelectorAll('.header__submenu-li')

				items.forEach((item) => {
					item.classList.add('active')
				})

				event.currentTarget.parentElement.classList.add('hide')
			})
		})
  };

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);

  header();

  // ── Country Selector Modal ──────────────────────────────────────────
  const initCountrySelectorModal = () => {
    const overlay  = document.getElementById('country-selector-overlay');
    const closeBtn = document.getElementById('country-modal-close');
    if (!overlay) return;

    const openModal = () => {
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      closeBtn && closeBtn.focus();
    };

    const closeModal = () => {
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
    };

    // Desktop + mobile triggers
    ['country-selector-trigger', 'country-selector-trigger-mobile'].forEach(id => {
      const btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', openModal);
    });

    closeBtn && closeBtn.addEventListener('click', closeModal);

    // Click outside modal box to close
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeModal();
    });

  };

  initCountrySelectorModal();
  document.addEventListener('shopify:section:load', initCountrySelectorModal);
})();

/* AU data logger visibility cache bump 1780372008976 */

/* AU hide legacy DL1000B cache bump 1780376947019 */

/* AU header TXU1 label override: only changes the Australia header card label for the Smart Transmitter. */
(function () {
  function isAustraliaStorefront() {
    return window.location.pathname.indexOf('/en-au/') === 0;
  }

  function relabelTxu1HeaderCard() {
    if (!isAustraliaStorefront()) return;

    document
      .querySelectorAll(
        '.header__submenu-products a[href*="/products/deye-smart-transmitter-sun-smart-tx01"]'
      )
      .forEach(function (link) {
        link.setAttribute('aria-label', 'Deye Smart Transmitter SUN-SMART-TXU1');

        link.querySelectorAll('.header__submenu-products-title, span, .unstyled-link').forEach(function (node) {
          var text = (node.textContent || '').trim();
          if (!text || text.indexOf('TX01') === -1) return;
          node.textContent = text.replace(/TX01/g, 'TXU1').replace(/DAE-TX01/g, 'SUN-SMART-TXU1');
        });

        link.querySelectorAll('img').forEach(function (image) {
          var alt = image.getAttribute('alt') || '';
          if (alt.indexOf('TX01') !== -1) image.setAttribute('alt', alt.replace(/TX01/g, 'TXU1'));
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relabelTxu1HeaderCard);
  } else {
    relabelTxu1HeaderCard();
  }

  window.addEventListener('load', function () {
    relabelTxu1HeaderCard();
    setTimeout(relabelTxu1HeaderCard, 300);
    setTimeout(relabelTxu1HeaderCard, 1200);
  });

  document.addEventListener('shopify:section:load', relabelTxu1HeaderCard);
  document.addEventListener('mouseover', function (event) {
    if (event.target && event.target.closest && event.target.closest('.header__submenu-products')) {
      relabelTxu1HeaderCard();
    }
  });
})();








/* AU Deye ESS desktop header category: show Deye ESS only in the Australia desktop header. */
(function () {
  var collectionHandle = 'deye-ess-au';
  var categoryLabel = 'Deye ESS';
  var triggerKey = 'au-deye-ess';
  var products = [
      {
        handle: "deye-ai-w5-1-b-ess",
        title: "Deye AI-W5.1-B ESS | 5.12kWh Stackable Low-Voltage Battery System",
        image: "https://cdn.shopify.com/s/files/1/0976/1040/0053/files/AI-W5.1-B-ESS.webp?v=1781573077",
        alt: "Deye AI-W5.1-B ESS residential stackable battery system"
      },
      {
        handle: "deye-ai-w5-1-b-pdu1-base",
        title: "Deye AI-W5.1-B-PDU1 + Base | Low-Voltage Stackable Battery Control & Mounting Set",
        image: "https://cdn.shopify.com/s/files/1/0976/1040/0053/files/AI-W5.10PDU1-B-BASE.png?v=1780377117",
        alt: "Deye AI-W5.1-B-PDU1 + Base | Low-Voltage Stackable Battery Control & Mounting Set"
      }
  ];

  function isAustraliaStorefront() {
    return window.location.pathname === '/en-au' || window.location.pathname.indexOf('/en-au/') === 0;
  }

  function isDesktopHeader() {
    return window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function activate(simpleMenu, activeKey) {
    simpleMenu.querySelectorAll('[data-simple-mega-trigger]').forEach(function (item) {
      var isActive = item.getAttribute('data-simple-mega-trigger') === activeKey;
      item.classList.toggle('is-open', isActive);
      var link = item.querySelector('.header__submenu-item');
      if (link) link.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
    simpleMenu.querySelectorAll('[data-simple-mega-panel]').forEach(function (panel) {
      panel.classList.toggle('is-open', panel.getAttribute('data-simple-mega-panel') === activeKey);
    });
  }

  function buildNavItem() {
    var item = document.createElement('li');
    item.className = 'header__submenu-li active header__submenu-li--panel';
    item.setAttribute('data-simple-mega-trigger', triggerKey);
    item.innerHTML =
      '<a href="/en-au/collections/' + collectionHandle + '" class="header__menu-item header__submenu-item link focus-inset header__submenu-item_has-submenu" aria-expanded="false" aria-label="' + categoryLabel + '">' +
        '<span class="hide-icon-caret">' + categoryLabel + '</span>' +
        '<svg class="icon icon-caret" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M1.5 1L5 4.5L8.5 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />' +
        '</svg>' +
      '</a>';
    return item;
  }

  function buildProductCard(product) {
    var item = document.createElement('li');
    item.className = 'header__submenu-products-item';
    item.innerHTML =
      '<a href="/en-au/products/' + product.handle + '" class="header__submenu-products-link" aria-label="' + escapeHtml(product.title) + '">' +
        '<div class="header__submenu-products-media">' +
          '<img src="' + product.image + '" width="240" height="240" loading="lazy" class="header__submenu-products-image" alt="' + escapeHtml(product.alt) + '">' +
        '</div>' +
        '<div class="header__submenu-products-content">' +
          '<span class="header__submenu-products-title">' + escapeHtml(product.title) + '</span>' +
        '</div>' +
      '</a>';
    return item;
  }

  function buildPanel() {
    var panel = document.createElement('div');
    panel.className = 'header__submenu-panel header__submenu-panel-products';
    panel.setAttribute('data-simple-mega-panel', triggerKey);
    panel.setAttribute('tabindex', '0');
    panel.innerHTML =
      '<div class="header__submenu-products">' +
        '<div class="header__submenu-products-top header__submenu-products-top--single">' +
          '<p class="header__submenu-products-heading">' + categoryLabel + '</p>' +
        '</div>' +
        '<ul class="header__submenu-products-list header__submenu-products-list--count-2 list-unstyled" role="list"></ul>' +
      '</div>';
    var list = panel.querySelector('.header__submenu-products-list');
    products.forEach(function (product) {
      list.appendChild(buildProductCard(product));
    });
    return panel;
  }

  function removeEssProductsFromAccessories(simpleMenu) {
    simpleMenu.querySelectorAll('[data-simple-mega-panel]').forEach(function (panel) {
      var heading = panel.querySelector('.header__submenu-products-heading');
      if (!heading || heading.textContent.trim() !== 'Accessories') return;
      products.forEach(function (product) {
        panel.querySelectorAll('a[href*="/products/' + product.handle + '"]').forEach(function (link) {
          var item = link.closest('.header__submenu-products-item, li');
          (item || link).remove();
        });
      });
    });
  }

  function ensureDeyeEssHeaderCategory() {
    if (!isAustraliaStorefront() || !isDesktopHeader()) return;
    document.querySelectorAll('[data-simple-mega-menu]').forEach(function (simpleMenu) {
      var nav = simpleMenu.querySelector('.header__submenu-simple-nav');
      var content = simpleMenu.querySelector('.header__submenu-simple-content');
      if (!nav || !content) return;
      if (!nav.querySelector('a[href*="/collections/accessories"]')) return;

      removeEssProductsFromAccessories(simpleMenu);

      var navItem = nav.querySelector('[data-simple-mega-trigger="' + triggerKey + '"]');
      if (!navItem) {
        navItem = buildNavItem();
        nav.appendChild(navItem);
      }

      var panel = content.querySelector('[data-simple-mega-panel="' + triggerKey + '"]');
      if (!panel) {
        panel = buildPanel();
        content.appendChild(panel);
      }

      if (!navItem.dataset.auDeyeEssBound) {
        var show = function () { activate(simpleMenu, triggerKey); };
        navItem.addEventListener('mouseenter', show);
        navItem.addEventListener('focusin', show);
        navItem.dataset.auDeyeEssBound = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureDeyeEssHeaderCategory);
  } else {
    ensureDeyeEssHeaderCategory();
  }
  window.addEventListener('load', function () {
    ensureDeyeEssHeaderCategory();
    setTimeout(ensureDeyeEssHeaderCategory, 300);
    setTimeout(ensureDeyeEssHeaderCategory, 1200);
  });
  document.addEventListener('shopify:section:load', ensureDeyeEssHeaderCategory);
})();

